module.exports = __webpack_public_path__ + "media/images/cart/cart_t1-9926986dfe45e7a93c7affcf1afe5d9e.gif";